var _path, _path2, _mask, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBackgroundLight(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1440 940",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F2F7",
    d: "M0 0h1440v940H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1440v940H0z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "background-light_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 940
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1440v940H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#background-light_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: -209,
    cy: 58,
    r: 440,
    fill: "url(#background-light_svg__paint0_radial)"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 962,
    cy: 1250,
    r: 720,
    fill: "url(#background-light_svg__paint1_radial)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "background-light_svg__paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 440 -440 0 -209 58)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3E6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background-light_svg__paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 720 -720 0 962 1250)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51DC8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundLight);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQ0MCIgaGVpZ2h0PSI5NDAiIHZpZXdCb3g9IjAgMCAxNDQwIDk0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjE0NDAiIGhlaWdodD0iOTQwIiBmaWxsPSIjRjBGMkY3Ii8+CjxyZWN0IHdpZHRoPSIxNDQwIiBoZWlnaHQ9Ijk0MCIgZmlsbD0id2hpdGUiLz4KPG1hc2sgaWQ9Im1hc2swIiBtYXNrLXR5cGU9ImFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIwIiB5PSIwIiB3aWR0aD0iMTQ0MCIgaGVpZ2h0PSI5NDAiPgo8cmVjdCB3aWR0aD0iMTQ0MCIgaGVpZ2h0PSI5NDAiIGZpbGw9IndoaXRlIi8+CjwvbWFzaz4KPGcgbWFzaz0idXJsKCNtYXNrMCkiPgo8Y2lyY2xlIG9wYWNpdHk9IjAuNSIgY3g9Ii0yMDkiIGN5PSI1OCIgcj0iNDQwIiBmaWxsPSJ1cmwoI3BhaW50MF9yYWRpYWwpIi8+CjxjaXJjbGUgb3BhY2l0eT0iMC41IiBjeD0iOTYyIiBjeT0iMTI1MCIgcj0iNzIwIiBmaWxsPSJ1cmwoI3BhaW50MV9yYWRpYWwpIi8+CjwvZz4KPGRlZnM+CjxyYWRpYWxHcmFkaWVudCBpZD0icGFpbnQwX3JhZGlhbCIgY3g9IjAiIGN5PSIwIiByPSIxIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgZ3JhZGllbnRUcmFuc2Zvcm09InRyYW5zbGF0ZSgtMjA5IDU4KSByb3RhdGUoOTApIHNjYWxlKDQ0MCkiPgo8c3RvcCBzdG9wLWNvbG9yPSIjRkYzRTZDIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0id2hpdGUiLz4KPC9yYWRpYWxHcmFkaWVudD4KPHJhZGlhbEdyYWRpZW50IGlkPSJwYWludDFfcmFkaWFsIiBjeD0iMCIgY3k9IjAiIHI9IjEiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiBncmFkaWVudFRyYW5zZm9ybT0idHJhbnNsYXRlKDk2MiAxMjUwKSByb3RhdGUoOTApIHNjYWxlKDcyMCkiPgo8c3RvcCBzdG9wLWNvbG9yPSIjNTFEQzhFIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0id2hpdGUiLz4KPC9yYWRpYWxHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };